'use client'

import { IconAlertTriangle } from '@tabler/icons-react'
import { toast } from '@/hooks/use-toast'
import { ConfirmDialog } from '@/components/confirm-dialog'
import { User } from '../data/schema'
import { useTranslation } from 'react-i18next'
import { reset_pass_user } from '@/api/user'
import { handleServerError } from '@/utils/handle-server-error'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  currentRow: User
  onConfirm: (passw: string) => void
}

export function UsersResetPassDialog({ open, onOpenChange, currentRow, onConfirm }: Props) {
  const i18n = useTranslation()

  const handleReset = () => {
    reset_pass_user(currentRow.id)
      .then(v => {
          toast({
            title: i18n.t('reseted_pass', { user: currentRow.name }),
          })
          onConfirm(v.password)
          onOpenChange(false)
      })
      .catch(e => {
        handleServerError(e)
      })
  }
  
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      handleConfirm={handleReset}
      title={
        <span className='text-destructive'>
          <IconAlertTriangle
            className='mr-1 inline-block stroke-destructive'
            size={18}
          />{' '}
          {i18n.t('reset_pass_user')}
        </span>
      }
      desc={
        <div className='space-y-4'>
          <p className='mb-2 text-right'>
            {i18n.t('reset_pass_confirm', { user: currentRow.name })}
          </p>
        </div>
      }
      confirmText={i18n.t('confirm')}
      cancelBtnText={i18n.t('cancel')}
      destructive
    />
  )
}
